import { Link } from "react-router-dom";
import Logo from "../images/logo.png";

const footerSections = [
  {
    title: "Platform",
    links: [
      { label: "Find Editors", href: "/gaming-video-editors" },
      { label: "Find Creators", href: "/creators" },
      { label: "Clipping Campaigns", href: "/clipping-campaigns" },
      { label: "Pricing", href: "/pricing" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "For Editors", href: "/for-editors" },
      { label: "For Clippers", href: "/for-clippers" },
      { label: "Streamer Editor Guide", href: "/streamer-editor" },
      { label: "FAQ", href: "/faq" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Terms", href: "/legal/terms" },
      { label: "Privacy", href: "/legal/privacy" },
      { label: "Cookies", href: "/legal/cookies" },
      { label: "Refunds", href: "/legal/refund" },
    ],
  },
];

const socialLinks = [
  { label: "Discord", href: "https://discord.gg/hKjGFSPzZt" },
  { label: "Instagram", href: "https://www.instagram.com/kre8content.comm" },
  { label: "YouTube", href: "https://www.youtube.com/channel/UCQQC7tisQFYewbxfh1ARQ9Q/" },
  { label: "X", href: "https://x.com/Kre8Content" },
  { label: "TikTok", href: "https://www.tiktok.com/@kre8content" },
];

function isExternalLink(href = "") {
  return /^https?:\/\//i.test(href);
}

function FooterLink({ link, className = "" }) {
  const baseClass = `text-sm text-zinc-400 transition hover:text-[#84ff00] ${className}`;

  if (isExternalLink(link.href)) {
    return (
      <a href={link.href} target="_blank" rel="noopener noreferrer" className={baseClass}>
        {link.label}
      </a>
    );
  }

  return (
    <Link to={link.href} className={baseClass}>
      {link.label}
    </Link>
  );
}

export default function Footer() {
  return (
    <footer className="mobile-safe border-t border-white/10 bg-[#07060d] text-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-14">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,2fr)]">
          <div className="max-w-sm">
            <Link to="/home" className="inline-flex items-center gap-3">
              <img className="h-9 w-auto" src={Logo} alt="Kre8 Content" />
              <span className="text-base font-black tracking-tight">Kre8 Content</span>
            </Link>

            <p className="mt-4 text-sm leading-6 text-zinc-400">
              The marketplace for creators, editors, and clippers to find each other, manage work, and grow content faster.
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              <Link
                to="/signup"
                className="rounded-full bg-[#84ff00] px-4 py-2 text-sm font-bold text-black transition hover:brightness-110"
              >
                Get Started
              </Link>
              <a
                href="https://discord.gg/hKjGFSPzZt"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full border border-white/10 px-4 py-2 text-sm font-semibold text-zinc-200 transition hover:border-[#84ff00]/40 hover:text-[#84ff00]"
              >
                Join Discord
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {footerSections.map((section) => (
              <nav key={section.title} aria-label={section.title}>
                <h2 className="text-xs font-bold uppercase tracking-[0.16em] text-zinc-500">
                  {section.title}
                </h2>
                <ul className="mt-4 space-y-3">
                  {section.links.map((link) => (
                    <li key={link.href}>
                      <FooterLink link={link} />
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
              {socialLinks.map((link) => (
                <FooterLink key={link.href} link={link} className="font-medium" />
              ))}
            </div>

            <p className="text-sm text-zinc-500">
              © Kre8 Content 2026. All rights reserved.
            </p>
          </div>

          <div className="mt-5 flex min-h-[40px] items-center">
            <div className="trustpilot-widget" data-locale="en-US" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="68c6e74ef7132c50734c1b45" data-style-height="40px" data-style-width="100%" data-token="6a08f12d-fa98-4631-b1b1-d2967a9baf7d">
              <a href="https://www.trustpilot.com/review/kre8content.com" target="_blank" rel="noopener noreferrer" className="text-sm text-zinc-500 transition hover:text-[#84ff00]">
                Review us on Trustpilot
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
